<template>
    <div class="main">
        <el-dialog
            :title="openData.title"
            :visible.sync="openData.state"
            :close-on-click-modal="false"
            width="700px"
            class="dialog_container"
            @close="dialogVisibleClone"
        >
            <div class="dialog_content">
                <el-form
                    :disabled="
                        openData.title == '查看' || openData.title == '审核'
                    "
                    label-position="left"
                    label-width="110px"
                    ref="formData"
                    :model="formData"
                    :rules="formDataRules"
                >
                    <el-form-item label="标题：" prop="title">
                        <el-input
                            v-model.trim="formData.title"
                            placeholder="请输入"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="内容：" prop="content">
                        <el-input
                            v-model.trim="formData.content"
                            :autosize="{ minRows: 2 }"
                            type="textarea"
                            placeholder="请输入内容"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="公开性质：" prop="publishingPlatform">
                        <el-checkbox-group
                            v-model="formData.publishingPlatform"
                        >
                            <el-checkbox label="0">公众号</el-checkbox>
                            <el-checkbox label="1">APP</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="状态：" prop="status">
                        <el-radio-group v-model="formData.status">
                            <el-radio label="1">启用</el-radio>
                            <el-radio label="0">禁用</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
                <el-form
                    v-if="openData.title == '审核'"
                    label-position="left"
                    label-width="120px"
                    ref="examine"
                    :model="examineData"
                    :rules="examineRules"
                >
                    <el-form-item label="审核结果" prop="auditFlag">
                        <el-radio-group v-model="examineData.auditFlag">
                            <el-radio label="0">审核通过</el-radio>
                            <el-radio label="2">审核不通过</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="审核意见：" prop="failureReason">
                        <el-input
                            type="textarea"
                            :autosize="{ minRows: 2 }"
                            v-model="examineData.failureReason"
                            placeholder="请输入审核意见"
                        ></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div
                slot="footer"
                class="dialog-footer dialog-footer-btn"
                v-if="openData.title != '查看'"
            >
                <el-button type="primary" @click="handleSubmit"
                    >确 定</el-button
                >
                <el-button @click="dialogVisibleClone">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    props: ["openData"],
    data() {
        return {
            examineData: {},
            examineRules: {},
            formData: {
                title: "",
                publishingPlatform: [],
                status: "1",
                content: "",
            },
            formDataRules: {},
            orgList: [],
            levelList: [],
        }
    },
    created() {
        this.formData = {
            title: "",
            publishingPlatform: [],
            status: "1",
            content: "",
        }
        if (this.openData.title == "新增") {
        } else {
            this.dataInfos()
        }
    },
    methods: {
        // 详情页信息
        dataInfos() {
            const self = this
            let params = {
                id: self.openData.id,
            }
            this.$http
                .request({
                    url: "/ypt/admin/guidance/info/get",
                    method: "POST",
                    data: params,
                })
                .then(async (res) => {
                    if (res.code == 200) {
                        self.formData = res.content
                        self.formData.status = String(res.content.status)
                        self.formData.publishingPlatform = res.content.publishingPlatform.split(
                            ","
                        )
                        //
                    } else {
                        this.$message.error(res.message)
                    }
                })
        },
        // 上传图片前的判断
        beforeAvatarUpload(file) {
            const isJPG =
                file.type === "image/jpeg" || file.type === "image/png"
            const isLt2M = file.size / 1024 / 1024 < 5
            if (!isJPG) {
                this.$message.error("上传头像图片只能是 JPG 格式!")
                return isJPG
            }
            if (!isLt2M) {
                this.$message.error("上传头像图片大小不能超过 5MB!")
                return isLt2M
            }
        },
        //自定义图片上传
        handleAvatarSuccess(res, file, name) {
            this.$set(this.formData, "photo", res.content)
        },
        handleSubmit() {
            this.$refs.formData.validate((valid) => {
                if (valid) {
                    if (
                        this.openData.title == "新增" ||
                        this.openData.title == "编辑"
                    ) {
                        let url = ""
                        let data = { ...this.formData }
                        data.publishingPlatform = data.publishingPlatform.toString()
                        data.status = Number(data.status)
                        url = "/ypt/admin/guidance/info/save"
                        this.$http
                            .request({
                                url: url,
                                method: "POST",
                                data: {
                                    ...data,
                                },
                            })
                            .then((res) => {
                                if (res.code == 200) {
                                    this.$message.success(res.message)
                                } else {
                                    this.$message.error(res.message)
                                }
                                // this.$emit("cancleService", true)
                                this.$emit("cancleAddress", true)
                                this.openData.state = false
                            })
                    }
                }
            })
            // this.$emit("cancleAddress", true)
        },
        dialogVisibleClone() {
            this.$emit("cancleAddress", false)
        },
    },
}
</script>
<style lang="less" scoped>
/deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    width: 200px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    .avatar-uploader .el-upload:hover {
        border-color: #409eff;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 100%;
        height: 200px;
        line-height: 200px;
        text-align: center;
    }
}
.avatar {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    font-size: 28px;
    color: #8c939d;
    width: 200px;
    height: 200px;
    line-height: 200px;
    img {
        width: 200px;
        height: 200px;
        line-height: 200px;
        display: block;
    }
}
</style>